import { useEffect } from "react";

// Adds `is-visible` to elements with data-reveal when they enter the viewport.
// Respects prefers-reduced-motion by revealing immediately.
export function useRevealOnScroll() {
  useEffect(() => {
    const body = document.body;
    body.classList.add("reveal-ready");

    const elements = Array.from(document.querySelectorAll("[data-reveal]"));
    if (!elements.length) {
      return () => body.classList.remove("reveal-ready");
    }

    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) {
      elements.forEach((el) => el.classList.add("is-visible"));
      return () => body.classList.remove("reveal-ready");
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const delay = Number(entry.target.dataset.revealDelay || "0");
            if (delay) {
              entry.target.style.transitionDelay = `${delay}ms`;
            }
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => {
      observer.disconnect();
      body.classList.remove("reveal-ready");
    };
  }, []);
}
